
function SourceBadge({ className, children }) {
    return <span
        className={`ml-3 text-sm font-medium me-2 px-1 py-0.5 rounded bg-gray-700 text-gray-300 ${className}`}
    >{children}</span>
}

export default SourceBadge